const raw = [
  import.meta.env.VITE_API_CASO,
  import.meta.env.VITE_API_CONSULTAS_AD,
  import.meta.env.VITE_API_GESTION_ASIGNACIONES,
  import.meta.env.VITE_API_GESTION_AUDIENCIAS,
  import.meta.env.VITE_API_GESTION_PARTES,
  import.meta.env.VITE_API_GESTION_CASOS,
].filter(Boolean);

const TRACE_TARGETS_FROM_ENV = raw
  .map(v => String(v).split(/\s|#/)[0].trim()) //<-- eliminar comentarios en línea
  .filter(Boolean)
  .map(v => v.replace(/\/+$|\s+$/g, '')) //<-- eliminar barras diagonales/espacios finales
  .filter(Boolean);

/* Exportar un arreglo que mezcla cadenas y expresiones regulares adecuado para `tracePropagationTargets` de Sentry */
export const SENTRY_TRACE_TARGETS: Array<string | RegExp> = [
  /* Mantener localhost para desarrollo local */
  "localhost",
  /^https?:\/\/localhost(:\d+)?/,
  /* agregar orígenes de API proporcionados por env */
  ...TRACE_TARGETS_FROM_ENV,
];

export default SENTRY_TRACE_TARGETS;